<template>
  <RouterView></RouterView>
</template>

<script setup></script>

<style lang="scss">
@import "@/scss/app.scss";
</style>
